// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectSearch_wrapper__CTZlW","closeIcon":"SelectSearch_closeIcon__3XO7Q"};